import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminPanel.css";
import { FaUser, FaTrash } from "react-icons/fa";

const AdminPanelJI6 = () => {
  const [astrologers, setAstrologers] = useState([]);
  const [userBookings, setUserBookings] = useState([]);
  const [filter, setFilter] = useState({
    name: "",
    expertise: "",
    phone: "",
    experience: "",
  });

  const token = localStorage.getItem("token"); // Retrieve token from localStorage

  useEffect(() => {
    fetchAstrologers();
    fetchBookings();
  }, []);

  // ✅ Fetch astrologers
  const fetchAstrologers = async () => {
    try {
      const response = await axios.get("https://back.varankal.com/api/astrologers/all");
      setAstrologers(response.data || []);
    } catch (error) {
      console.error("Error fetching astrologers:", error);
    }
  };
  // ✅ Fetch bookings
  const fetchBookings = async () => {
    try {
      const response = await axios.get("https://back.varankal.com/api/bookings", {
        withCredentials: true,
        headers: {
          "Cache-Control": "no-cache",
        },
      });
      setUserBookings(response.data);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  // ✅ Update booking status
  const updateBookingStatus = async (bookingId, status) => {
    try {
      await axios.put(
        `https://back.varankal.com/api/bookings/${bookingId}/status`,
        { status },
        {
          withCredentials: true,
        }
      );
      fetchBookings(); // Refresh bookings
    } catch (error) {
      console.error("Error updating booking status:", error);
    }
  };

  // ✅ Delete booking
  const deleteBooking = async (id) => {
    try {
      if (window.confirm("Are you sure you want to delete this booking?")) {
        await axios.delete(`https://back.varankal.com/api/bookings/${id}`, {
          withCredentials: true,
        });
        fetchBookings();
      }
    } catch (error) {
      console.error("Error deleting booking:", error);
    }
  };

  // ✅ Delete astrologer
  const deleteAstrologer = async (id) => {
    try {
      if (window.confirm("Are you sure you want to delete this astrologer?")) {
        await axios.delete(`https://back.varankal.com/api/astrologers/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        fetchAstrologers();
      }
    } catch (error) {
      console.error("Error deleting astrologer:", error);
    }
  };


  // ✅ Filter astrologers
  const filteredAstrologers = astrologers.filter((astro) => {
    return (
      (filter.name === "" || astro.name.toLowerCase().includes(filter.name.toLowerCase())) &&
      (filter.expertise === "" || astro.expertise === filter.expertise) &&
      (filter.phone === "" || astro.phone.includes(filter.phone)) &&
      (filter.experience === "" || astro.experience.toString() === filter.experience)
    );
  });

  return (
    <div className="admin-containerJI6">
      <h2 className="admin-titleJI6">🔮  Astrology Bookings</h2>

      {/* 📅 Booking Verification Section */}
      <div className="admin-sectionJI6">
        <h3>📅 All Bookings</h3>
        <div className="admin-listJI6">
          {userBookings.length > 0 ? (
            userBookings.map((booking) => (
              <div key={booking._id} className="admin-cardJI6">
                <p><strong>ID:</strong> {booking._id}</p>
                <p><strong>Status:</strong> {booking.status}</p>
                <p><strong>User:</strong>{" "}
                  {booking.userId?.basicDetails
                    ? `${booking.userId.basicDetails.firstName} ${booking.userId.basicDetails.lastName}`
                    : "No user"}
                </p>
                <p><strong>Astrologer:</strong> {booking.astrologerId?.name || "No astrologer"}</p>
                <p><strong>Date:</strong> {new Date(booking.dateTime).toLocaleString()}</p>

                <button className="approve-btnJI6" onClick={() => updateBookingStatus(booking._id, "approved")}>
                  ✅ Approve
                </button>
                <button className="pending-btnJI6" onClick={() => updateBookingStatus(booking._id, "pending")}>
                  ⏳ Pending
                </button>
                <button className="cancel-btnJI6" onClick={() => updateBookingStatus(booking._id, "canceled")}>
                  ❌ Cancel
                </button>
                <button className="delete-btnJI6" onClick={() => deleteBooking(booking._id)}>
                  🗑️ Delete
                </button>
              </div>
            ))
          ) : (
            <p>No bookings available.</p>
          )}
        </div>
      </div>

      {/* 📜 Manage Astrologers Section */}
      <div className="admin-sectionJI6">
        <h3>📜 Manage Astrologers</h3>
        <div className="astrologer-formJI6">
          <input
            type="text"
            placeholder="Search by Name"
            value={filter.name}
            onChange={(e) => setFilter({ ...filter, name: e.target.value })}
          />
          <select
            value={filter.expertise}
            onChange={(e) => setFilter({ ...filter, expertise: e.target.value })}
          >
            <option value="">Select Expertise</option>
            <option value="Vedic Astrology">Vedic Astrology</option>
            <option value="Marriage Compatibility">Marriage Compatibility</option>
            <option value="Palm Reading & Tarot">Palm Reading & Tarot</option>
          </select>
          <input
            type="text"
            placeholder="Search by Phone"
            value={filter.phone}
            onChange={(e) => setFilter({ ...filter, phone: e.target.value })}
          />
          <input
            type="number"
            placeholder="Filter by Experience (years)"
            value={filter.experience}
            onChange={(e) => setFilter({ ...filter, experience: e.target.value })}
          />
        </div>

        <div className="admin-listJI6">
          {filteredAstrologers.length > 0 ? (
            filteredAstrologers.map((astro) => (
              <div key={astro._id} className="admin-cardJI6">
                <FaUser className="admin-iconJI6" />
                <h4>{astro.name}</h4>
                <p>Expertise: {astro.expertise}</p>
                <p>Phone: {astro.phone}</p>
                <p>Experience: {astro.experience} years</p>
                <button
                  className="delete-btnJI6"
                  onClick={() => deleteAstrologer(astro._id)}
                >
                  <FaTrash /> Delete
                </button>
              </div>
            ))
          ) : (
            <p>No astrologers match the filter criteria.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanelJI6;
